<template>
    <form @submit="book">
        <button type="submit" class="expand">Book Now</button>
    </form>
</template>

<script>
import makeBookings from '../booking';
import AgreeBeforeBooking from '../Policies/AgreeBeforeBooking'

export default {
  name: 'BookNowButton',
  methods: {
    async book(event) {
      event.preventDefault();
      this.$emit('emit-global-loading', true);
      const { data } = await makeBookings();
      const { uuid } = data;
      const url = `/order/${uuid}`;
      window.location.href = url;
    },
  },

  components: {
    AgreeBeforeBooking
  }
};
</script>

<style scoped>

</style>
